import React from 'react';
import { AiFillInstagram } from 'react-icons/ai';
import { FaFacebookF, FaGithubAlt, FaHeadphones, FaMapMarkerAlt, FaTwitter } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logoW from '../../assets/tripaide-logo-w.svg';

const Footer = () => {

    return (
        <div className='bg-gray-800'>
            <div className="bg-trans">
                <div className="w-11/12 mx-auto">
                    <div className="py-8 lg:flex justify-between">
                        <div className="lg:w-1/3 mt-4 mr-8">
                            <div className="pb-2">
                                <Link className="" to="/home">
                                    <img className="w-40 block cursor-pointer" src={logoW} alt="tripaide" />
                                </Link>
                            </div>
                            <small className="text-gray-400 block mt-4 mb-3"><span className="text-yellow-500">tripaide, Inc.</span> provide facilities to the travelers to find tour partner to minimize their tour cost and also the travel & tour companies to provide better service with a very interactive content management system to easily access the information etc!</small>
                            <small className="text-gray-400">Copyright &copy; 2022. <span className="text-white">Tanmay Kumar & Md. Yakub Ali.</span></small>
                            <div>
                                <Link to="/desclaimer" className="text-gray-400 hover:text-yellow-500"><small>Desclaimer.</small></Link>
                                <Link to="/tnc" className="px-2 text-gray-400 hover:text-yellow-500"><small>Terms & Conditions.</small></Link>
                                <Link to="/privacy" className="text-gray-400 hover:text-yellow-500"><small>Privacy Policy.</small></Link>
                            </div>
                        </div>
                        <div className='md:flex lg:justify-around lg:w-3/5'>
                            <div className="lg:order-first md:order-last lg:w-3/12 mt-4 pt-2">
                                <h6 className="mb-2 text-yellow-500"><span className="border-b-2">Quick L</span>inks</h6>
                                <Link className="block text-gray-400 hover:text-yellow-500" to="/info">FAQ</Link>
                                <Link className="block text-gray-400 hover:text-yellow-500" to="/feedback">Feedback</Link>
                                <Link className="block text-gray-400 hover:text-yellow-500" to="/career">Career</Link>
                                <Link className="block text-gray-400 hover:text-yellow-500" to="/payment">Payment Options</Link>
                                <Link className="block text-gray-400 hover:text-yellow-500" to="/return">Return Policy</Link>
                            </div>
                            <div className="lg:order-last md:order-first md:w-2/5 lg:w-5/12 mt-4 pt-2 mb-3 text-white">
                                <h6 className="mb-2 text-yellow-500"><span className="border-b-2 border-main">Connect Wi</span>th Us</h6>
                                <div className="my-2 flex items-center">
                                    <small className="pr-2">
                                        <FaMapMarkerAlt />
                                    </small>
                                    <small>Dhanmondi, Bangladesh</small>
                                </div>
                                <div className="my-2 flex items-center">
                                    <small className="pr-2">
                                        <FaHeadphones />
                                    </small>
                                    <small>+880123, +8801710023333</small>
                                </div>
                                <h6 className="mt-6 mb-3 text-yellow-500"><span className="border-b-2 border-main">Follow U</span>s On</h6>
                                <div className="my-2 flex">
                                    <Link to="/social">
                                        <FaFacebookF className='mr-3 hover:text-yellow-500' />
                                    </Link>
                                    <Link to="/social">
                                        <FaTwitter className='mr-3 hover:text-yellow-500' />
                                    </Link>
                                    <Link to="/social">
                                        <AiFillInstagram className='mr-3 hover:text-yellow-500' />
                                    </Link>
                                    <Link to="/social">
                                        <FaGithubAlt className='mr-3 hover:text-yellow-500' />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;